import { i18n } from '@lib/i18n';
import { t } from '@lingui/macro';

export function money(value, currency = 'USD') {
  const amount = Number(value === null || value === undefined ? 0 : value);
  const safeAmount = Number.isFinite(amount) ? amount : 0;
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
    }).format(safeAmount);
  } catch (e) {
    // Workspace currencies are free-form codes; Intl rejects unknown ones.
    return `${safeAmount.toFixed(2)} ${currency}`;
  }
}

export function dateShort(value) {
  if (!value) return i18n._(t`No date`);
  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(new Date(value));
}

export function bytes(value) {
  if (value < 1024) return `${value} B`;
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`;
  return `${(value / (1024 * 1024)).toFixed(1)} MB`;
}

export function errorMessage(error) {
  if (error && error.message) return error.message;
  if (typeof error === 'string') return error;
  return i18n._(t`Something went wrong`);
}
